<ng-container *ngIf="showSuccess">
  <section
    class="section-card d-flex justify-content-center align-items-center"
  >
    <div class="card shadow p-3 card-ctn">
      <div class="card-body">
        <div
          class="w-100 d-flex justify-content-center mb-5 border-bottom pb-4"
        >
          <img src="/assets/img/parkit-logo.png" alt="logo" width="300" />
        </div>
        <h2 class="color-success mb-5 text-center">
          <i class="fas fa-check-circle icon-success"></i>{{ texts.openpaySuccessTitle }}
        </h2>
        <h4 class="text-center mb-3">
          {{ texts.openpaySuccessMessage }}
        </h4>
        <h4 class="text-center mb-5 text-underline" style="color: #0d38a1">
          {{ texts.openpayReferenceNumberLabel }} {{ numReferencia }}
        </h4>
        <h5 class="text-center mb-3">
          {{ texts.brandTagline }}
        </h5>
        <div class="w-100 d-flex justify-content-center">
          <button
            class="btn btn-custom-success mt-4"
            type="button"
            (click)="onWalletQR()"
          >
            {{ texts.continueButton }}
          </button>
        </div>
      </div>
    </div>
  </section>
</ng-container>

<ng-container *ngIf="showError">
  <section
    class="section-card d-flex justify-content-center align-items-center"
  >
    <div class="card shadow p-3 card-ctn">
      <div class="card-body">
        <div
          class="w-100 d-flex justify-content-center mb-5 border-bottom pb-4"
        >
          <img src="/assets/img/parkit-logo.png" alt="logo" width="300" />
        </div>
        <h2 class="color-error mb-5 text-center">
          <i class="fas fa-times-circle icon-error"></i> {{ texts.openpayErrorTitle }}
        </h2>
        <h4 class="text-center mb-3">
          {{ texts.openpayErrorMessage }}
        </h4>
        <h5 class="text-center mb-3">
          {{ texts.brandTagline }}
        </h5>
        <div class="w-100 d-flex justify-content-center">
          <button
            class="btn btn-custom-error mt-4"
            type="button"
            (click)="onHome()"
          >
            {{ texts.continueButton }}
          </button>
        </div>
      </div>
    </div>
  </section>
</ng-container>
